import { keyframes } from '@chakra-ui/system';
import { mode } from '@chakra-ui/theme-tools';

type Dict = Record<string, any>;
const parts = ['track', 'filledTrack', 'panel'];

const barberpole = () =>
  keyframes({
    '0%': { left: '-100%' },
    '100%': { left: '0' },
  });

const filledStyle = (props: Dict) => {
  const { colorScheme: c, isIndeterminate } = props;
  const bgColor: string = mode(`${c}.500`, `${c}.200`)(props) as string;

  const stripeAnimationDuration = 7;
  const stripeWidth = 1;
  const stripeGap = 1;
  const stripeColor = 'rgba(0,0,0,0.05)';
  const stripeGapColor = 'rgba(0,0,0,0)';

  const stripeStyle: Dict = {
    background: `repeating-linear-gradient(
    45deg,
    ${stripeColor},
    ${stripeColor} ${stripeWidth}rem,
    ${stripeGapColor} ${stripeWidth}rem,
    ${stripeGapColor} ${stripeWidth + stripeGap}rem
  )`,
    // override chakra's hardcoded minWidth
    minWidth: '200% !important',
    backgroundSize: '200%',
    animation: `${stripeAnimationDuration}s linear infinite  ${barberpole()} !important`,
  };

  return {
    ...(isIndeterminate ? stripeStyle : { bgColor }),
  } as Dict;
};

const baseStyleLabel = { lineHeight: '1', fontSize: '0.25em', fontWeight: 'bold', color: 'white' };

const baseStyleTrack = (props: Dict) => {
  return { backgroundColor: mode(`slate.100`, `white`)(props) };
};

const baseStyleFilledTrack = (props: Dict) => {
  return { transition: 'all 0.3s', ...filledStyle(props) };
};

const baseStyle = (props: Dict) => ({
  label: baseStyleLabel,
  filledTrack: baseStyleFilledTrack(props),
  track: baseStyleTrack(props),
});

const sizes = { xs: { track: { h: '0.25rem' } } };
const defaultProps = { size: 'xs', colorScheme: 'light-blue' };
export const Progress = { parts, sizes, baseStyle, defaultProps };
